<template>
    <div class="container">
        <Nav></Nav>
        <div style="width:100%; height:80px;"></div>
        <Row height="720" bg="assets/pc/service/spread/p1_bg.jpg"> </Row>
        <Row height="900" bgColor="#fff">
            <div class="pos2">
                <img src="@/assets/pc/service/spread/pos2_banner.png" />
                <h1>全方位构建品牌传播体系 提升品牌商业价值</h1>
                <p>致力于构建全方位的品牌体系，通过品牌管理与咨询、公关传播、社会化媒体传播、事件营销等，<br />助力客户管理品牌战略定位与品牌价值，打造全内容传播解决方案。</p>
            </div>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from "@/components/pc/nav.vue";
import Footer from "@/components/pc/footer.vue";
import Row from "@/components/pc/Row.vue";
export default {
    name: "pc-service-spread",
    components: { Nav, Footer, Row },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
};
</script>
<style scoped>
.pos2 {
    width: 100%;
    height: 100%;
    text-align: center;
}
.pos2 p {
    font-size: 1.8rem;
    line-height: 5rem;
}

@media only screen and (max-width: 2048px) {
    .pos2 img {
        margin-top: 110px;
        width: calc(1000px * var(--scale));
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 100px 0 60px 0;
    }
}

@media only screen and (min-width: 2049px) {
    .pos2 img {
        margin-top: 130px;
        width: 1000px;
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 160px 0 80px 0;
    }
}

</style>
